<template>
  <div id="app">
    <transition name="fade">
      <router-view />
    </transition>
    <Spinner :loading="isLoading" />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import Spinner from "./components/molecules/Spinner/Spinner.vue";
import { LOCALES } from "@/enums/locales";

export default {
  name: "App",
  components: { Spinner },
  data() {
    return {
      localeObject: {
        pt_pt: "PT",
        es_es: "ES",
      },
    };
  },
  methods: {
    ...mapMutations({
      setLocalesDropdown: "AuthenticationModule/setLocalesDropdown",
    }),
    preSelectLocalesDropdown(locales, locale) {
      locales.map((item) => {
        if (item.value === this.localeObject[locale]) {
          item.selected = true;
        } else {
          item.selected = false;
        }
        return item;
      });
      return locales;
    },
  },
  computed: {
    ...mapGetters({
      isLoading: "SpinnerModule/isLoading",
      getLocaleDropdown: "AuthenticationModule/getLocaleDropdown",
    }),
  },
  mounted() {
    const locale = localStorage.getItem("locale");
    let locales = this.getLocaleDropdown;

    if (locale) {
      locales = this.preSelectLocalesDropdown(locales, locale);
      this.$i18n.locale = LOCALES[locale];
    } else if (navigator.language === "es-ES" || navigator.language === "es") {
      const spanishLabel = "es_es";
      this.$i18n.locale = LOCALES[spanishLabel];
      locales = this.preSelectLocalesDropdown(locales, spanishLabel);
    } else {
      this.$i18n.locale = LOCALES["pt_pt"];
    }

    this.setLocalesDropdown(locales);
  },
};
</script>

<style lang="scss" scoped></style>
